// React
import React, { useState, useRef } from "react";

// React Async
import Async from "react-async";

// Components
import { Form } from "react-bootstrap";
import {
  ProgressBar,
  Modal,
  Button,
  Table,
  Row,
  Col,
  Container,
  Badge
} from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import ListSelectionTypeahead from "../components/ListSelectionTypeahead";

// Internal Libs
import { useFormFields } from "../libs/hooksLib";
import AffinityAPI from "../libs/AffinityAPI";
import * as EventifyAPI from "../libs/EventifyAPI";

// CSV
import parse from "csv-parse";

// Style
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-bootstrap-typeahead/css/Typeahead-bs4.css";

// Local Storage
import ls from "local-storage";

// AWS
import config from "../config";
import { API, Auth } from "aws-amplify";

// UUID
const uuidv4 = require("uuid/v4");

export default function ListCreatorModal(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [uploadButtonTitle, setUploadButtonTitle] = useState("Create");

  const [fields, handleFieldChange] = useFormFields({
    listName: ""
  });
  const [includeListsFields, handleIncludeListsChange] = useFormFields({
    includeLists: ""
  });
  const [excludeListsFields, handleExcludeListsChange] = useFormFields({
    excludeLists: ""
  });

  const listNameRef = useRef(null);

  const options = ["Meme 1", "Meme 2", "Meme 3"];
  const multiple = true;

  function validateForm() {
    return true;
  }

  async function uploadList() {
    var list = {};

    list.listid = uuidv4();
    list.name = nameRef.current.value;

    const localStorageAuthData = ls.get('authData');

    if (localStorageAuthData == null) {
      // dont do anything, they are unauth
      list.creator = {"email": props.email};
    } else {
      const providerType = localStorageAuthData.providerType;
      if (providerType === "amazon") {
        list.creator = localStorageAuthData;
      } else if (providerType === "google") {
        list.creator = localStorageAuthData;
      }
    }

    const result = await EventifyAPI.createList(
      list.listid,
      list.name,
    );
    return result;
  }

  async function handleSubmit(event) {
    setIsLoading(true);
    try {
      const result = await uploadList();
      window.location.reload(); // FIXME
    } catch (e) {
      setIsLoading(false);
    }
  }

  // <Row>
  //   <Col>
  //     <Form.Label>Include Lists</Form.Label>
  //     <ListSelectionTypeahead
  //       id="includeLists"
  //       email={props.email}
  //       organizationid={props.organizationid}
  //     />
  //   </Col>
  //   <Col>
  //     <Form.Label>Exclude Lists</Form.Label>
  //     <ListSelectionTypeahead
  //       id="excludeLists"
  //       email={props.email}
  //       organizationid={props.organizationid}
  //     />
  //   </Col>
  // </Row>

  const nameRef = React.useRef();

  return (
    <Modal
      show={props.visible}
      onHide={props.onCancel}
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Create New Event</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="listName">
            <Form.Label>Event Name</Form.Label>
            <Form.Control ref={nameRef} autoFocus type="text" />
          </Form.Group>
        </Form>

      </Modal.Body>
      <Modal.Footer>
        <LoaderButton
          block
          type="submit"
          onClick={handleSubmit}
          isLoading={isLoading}
        >
          {uploadButtonTitle}
        </LoaderButton>
      </Modal.Footer>
    </Modal>
  );
}
